import React from "react";
import styled from "styled-components";

const ResultRow = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
`;

const ResultItem = styled.div`
  font-size: 14px;
  margin: 8px;
`;

const Result = ({ result }) => (
  <ResultRow>
    <ResultItem>{result.n}</ResultItem>
    <ResultItem>{result.fibDate}</ResultItem>
  </ResultRow>
);

export default Result;
